export default "__VITE_ASSET__CnPgck7f__"